import React from 'react';
import { useContext } from 'react';

import FieldContainer from 'src/presentation/components/forms/FieldContainer';
import FormContext from 'src/presentation/contexts/FormContext';
import MappingToSelector from './MappingToSelector';
import { getErrorMessage } from 'src/actions/integrations/sso/editorHelpers';

type MappingToSelectorFieldProps = {
  'data-aid': string;
  attr: string;
  description: string;
  label: string;
  options: Array<{ label: string; value: string }>;
  placeholder?: string;
};

const MappingToSelectorField = ({
  attr,
  'data-aid': dataAid,
  description,
  label,
  options,
  placeholder,
}: MappingToSelectorFieldProps) => {
  const { errors } = useContext(FormContext);

  const error = errors.find(err => err.attr === attr);

  return (
    <FieldContainer
      control={<MappingToSelector attr={attr} data-aid={dataAid} placeholder={placeholder} options={options} />}
      data-aid={dataAid ? `${dataAid}-field-container` : undefined}
      description={description}
      error={error ? getErrorMessage(error) : undefined}
      label={label}
      preventContentFromOverflow
    />
  );
};

export default MappingToSelectorField;
